import { connect } from 'react-redux'
import {
  setCurrentSearchPhrase, setSearchPaginationMode,
  setSearchResponse,
  setSearchState
} from 'redux/actions'
import Infinite from 'pages/search/Infinite'

const mapDispatchToProps = dispatch => ({
  setSearchState: (props) => dispatch(setSearchState(props)),
  setSearchResponse: response => dispatch(setSearchResponse(response)),
  setCurrentSearchPhrase: searchPhrase => dispatch(setCurrentSearchPhrase(searchPhrase)),
  setSearchPaginationMode: paginationMode => dispatch(setSearchPaginationMode(paginationMode))
})

export default connect(null, mapDispatchToProps)(Infinite)
